/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class Record
{
  constructor (path, config)
  {
    this.path = path;

    Object.assign(this, config);
  }


  parent (application)
  {
    return application;
  }


  upcastData (data)
  {
    return data != null ? this.upcastCass(data) : null;
  }


  upcastCass (cass)
  {
    return (this.upcast ?? []).reduce((cass, upcast) => upcast(cass), cass);
  }


  getParent (application, args)
  {
    const parent = this.parent(application, args);

    if (parent?.entity === undefined)
    {
      return { entity: parent, logic: parent };
    }

    return parent;
  }


  upsert (application, { args, data })
  {
    const { entity } = this.getParent(application, args);

    if (data !== null)
    {
      this.load(entity, data);
    }
  }


  remove (application, { args, data })
  {
    if (data !== null)
    {
      return;
    }

    const { entity } = this.getParent(application, args);

    if (entity !== null)
    {
      this.unload(entity, args);
    }
  }


};
